import React, {Component} from "react";
import {request} from "api-client";
import UsersFormView from "./UsersFormView";
import FormViewContainer from "../../../components/Letflow/ViewContainer/FormViewContainer";
import {ROLES} from "../../../api-client/core/authentication/utils";
import GlobalConfirmationDialog from "../../../components/Letflow/Dialog/GlobalConfirmationDialog";
import localization from "../../../config/localization";
import {makeUrlWithTableParams} from "../../../utils";
import availableLanguages from "../../../config/localization/availableLanguages.json";

class FormContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: props.name,
      email: props.email,
      description: props.description,
      image: { src: props.image, file: null },
      roles: [],
      roleId: props.roleId,
      language: props.language || '',
      selectedCreator: props.selectedCreator
    };
  }

  requestRoles = () =>
    request.role
      .getAll()
      .then(roles => roles.filter(role => !([ROLES.projectInviteeId].includes(role.id))))
      .then(roles => this.setState({ roles }));


  handleSubmitRequest = () =>
    this.props.submitRequest(this.state).then(() => {
      if (this.props.type === "create") {
        GlobalConfirmationDialog.show({
          title: localization.get("user.created"),
          content: localization.get("user.email_sent", this.state.email),
          request: () => Promise.resolve(),
          confirmationLabel: localization.get("accept"),
          onClose:  this.props.history.push(makeUrlWithTableParams("/panel/users"))
        });
      } else {
        this.props.history.push(makeUrlWithTableParams("/panel/users"))
      }
    });

  onImageChange = image => this.setState({ image });
  onAsyncCreatorChange = selectedCreator => this.setState({ selectedCreator })

  onSubmitValidation = () => {
      return true
  }



  render = () => {
    const {
      disabled,
      name,
      email,
      description,
      image,
      roles,
      roleId,
      language,
      selectedCreator,
    } = this.state;


    return (
      <div>
        <FormViewContainer
          title={this.props.formTitle}
          initializationRequest={() => this.requestRoles()}
          onBack={() => this.props.history.goBack()}
          submitRequest={this.handleSubmitRequest}
          validation={this.onSubmitValidation}
          onRequestingStateChanged={value => this.setState({ disabled: value })}
        >
          <UsersFormView
            name={name}
            email={email}
            description={description}
            roleId={roleId}
            roles={roles}
            language={language}
            image={image}
            selectedCreator={selectedCreator}
            onAsyncCreatorsChange={this.onAsyncCreatorChange}
            onChange={e => this.setState({ [e.target.id]: e.target.value })}
            onImageChange={image => this.setState({ image })}
            disabled={disabled}
            availableLanguages={availableLanguages}
          />
        </FormViewContainer>
      </div>
    );
  };
}

export default FormContainer;
